<template>
  <section class="cert section">
    <div class="container">
      <div class="section-header">
        <span class="section-label">资质认证</span>
        <h2 class="section-title">权威资质，值得信赖</h2>
        <p class="section-desc">通过多项国家级认证与行业资质，为政务项目提供合规保障</p>
      </div>

      <div class="cert__grid">
        <div v-for="cert in certs" :key="cert.title" class="cert__item">
          <div class="cert__icon">{{ cert.icon }}</div>
          <h4>{{ cert.title }}</h4>
          <p>{{ cert.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CertSection',
  data() {
    return {
      certs: [
        { icon: '🏅', title: '国家高新技术企业', desc: '国家级认定证书' },
        { icon: '📜', title: '软件著作权', desc: '30+项自主知识产权' },
        { icon: '🔐', title: '等保测评认证', desc: '信息安全等级保护' },
        { icon: '✅', title: 'ISO质量管理体系', desc: 'ISO9001认证' },
        { icon: '💼', title: 'CMMI认证', desc: '软件能力成熟度模型' },
        { icon: '🌟', title: '信创产品认证', desc: '国产化适配认证' }
      ]
    }
  }
}
</script>

<style scoped>
.cert {
  background: #f7f9fc;
}

.cert__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cert__item {
  background: #fff;
  border-radius: 12px;
  padding: 28px 16px;
  text-align: center;
  border: 1px solid #eef1f6;
  transition: all 0.25s;
}

.cert__item:hover {
  box-shadow: 0 8px 24px rgba(0, 82, 217, 0.08);
  transform: translateY(-2px);
}

.cert__icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.cert__item h4 {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 6px;
}

.cert__item p {
  font-size: 12px;
  color: #888;
}

@media (max-width: 960px) {
  .cert__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 560px) {
  .cert__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
